module.exports = __webpack_public_path__ + "img/3.947bc402.jpg";